const fetchReports: Object = async (
  perPage: number = 15,
  page: number = 1,
  query: string = "",
  topic: string
) => {
  let params: any = {
    per_page: perPage,
    page: page,
  };

  if (query.length >= 3) {
    params.query = query;
  }

  // If topic exists, append it to params
  if (topic) params.topic = topic;

  const { data: reports } = await dataFetch("/reports",
    {
      params: params
    }
  );

  return reports.value;
};

const fetchReport: Object = async (id: number) => {
  const { data: report } = await dataFetch(`/reports/${id}`);

  return report.value;
};


const createReport: any = async (body: Object) => {
  const { data, status, error } = await dataFetch("/reports",
    {
      method: "post",
      body: body
    }
  );
  
  let errorMessages;
  if (status._value == "error") {  
    errorMessages = error._object[error._key].data;
  }

  return { data, status, errorMessages };
};

const fetchUserReports: any = async ( perPage: number = 15, page: number = 1,) => {
  let params: any = {
    per_page: perPage,
    page: page,
  };

  const { data: reports } = await dataFetch("/user/reports",
    {
      params: params
    }
  );

  return reports.value;
};

/** Unopened support messages; a red dot on Customer support for the support team */
const useUnopenedReportsCount = () => useState<number>("unopenedReportsCount", () => 0);

const refreshUnopenedReportsCount = async () => {
  const count = useUnopenedReportsCount();
  const response: any = await dataFetch("/reports/unopened-count");

  // Keep the last known value when the request fails
  const fetched = response?.data?.value?.count;
  if (typeof fetched === "number") count.value = fetched;
};

/**
 * Support report topics: API uses English `value`; labels from
 * `form_fields.report_topics.options.{i18nKey}` in locale files.
 */
const REPORT_TOPICS_DEFINITION: readonly { value: string; i18nKey: string }[] = [
  { value: "Unable to control lights", i18nKey: "unable_to_control_lights" },
  { value: "Unable to change light intensity", i18nKey: "unable_to_change_light_intensity" },
  { value: "Unable to change light zone", i18nKey: "unable_to_change_light_zone" },
  { value: "All lights do not work", i18nKey: "all_lights_do_not_work" },
  { value: "Some lights do not work", i18nKey: "some_lights_do_not_work" },
];

const retrieveReportsTopics = (): string[] =>
  REPORT_TOPICS_DEFINITION.map((row) => row.value);

/** USelect: `value` for API/filter, `label` translated for current locale */
const useReportTopicSelectOptions = () => {
  const { t } = useI18n();
  return computed(() =>
    REPORT_TOPICS_DEFINITION.map(({ value, i18nKey }) => ({
      value,
      label: t(`form_fields.report_topics.options.${i18nKey}`),
    }))
  );
};

export {
  fetchReports,
  fetchReport,
  createReport,
  fetchUserReports,
  useUnopenedReportsCount,
  refreshUnopenedReportsCount,
  retrieveReportsTopics,
  useReportTopicSelectOptions,
};
